module.exports = __webpack_public_path__ + "static/media/mastercard.dca3c42a.png";